import Ouroffices from '../PageComponents/Contactus/Ouroffices'
import ConatactCard from '../PageComponents/Contactus/ConatactCard'
import Shopnow from '../PageComponents/Home/Shopnow'
import UploadCV from '../PageComponents/Contactus/UploadCV'
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ResponsiveIframe from './ResponsiveIframe';
import MetaTags from '../components/MetaTags';
const Contactus = () => {
  document.title = "Contact Dosing Pump Supplier UAE | Positive Metering FZE"
   const metaDetails = {
    title: 'Contact Dosing Pump Supplier UAE | Positive Metering FZE',
    description: 'Contact Positive Metering FZE, a trusted dosing pump supplier in UAE. Get quotes, technical support and enquiries for metering pumps across MENA region.',
  keywords: 'Metering Pump Manufacturer in India',
    slug: '',
      alt: 'Contact Dosing Pump Supplier UAE - Positive Metering FZE',
  };

  const location = useLocation();
  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      // Use a timeout to ensure the page is fully rendered before scrolling
      setTimeout(() => {
        window.scrollTo({
          top: location.state.scrollTo,
          behavior: 'smooth'
        });
      }, 100); // Adjust this timeout as needed
    }
  }, [location.state]);
  return (
    <>
     <MetaTags
      title={metaDetails.title}
      description={metaDetails.description}
      keywords={metaDetails.keywords}
      slug={metaDetails.slug}
      alt={metaDetails.alt}
    />
      <ConatactCard />
      <Shopnow />
      <ResponsiveIframe/>
      <Ouroffices />
      <UploadCV />

    </>
  )
}

export default Contactus